<template>
  <!-- 410 Gone is thrown by useJobData for a deactivated job offer. -->
  <!-- Pass i18n keys (not resolved strings) so the copy is translated inside the -->
  <!-- component after it applies the jobshop locale — see ErrorPageNavigation. -->
  <ErrorPageNavigation
    v-if="error?.statusCode === 410"
    title-key="job-gone.title"
    text-key="job-gone.text"
  />

  <!-- 404 pages get the same helpful navigation instead of a bare error screen. -->
  <ErrorPageNavigation
    v-else-if="error?.statusCode === 404"
    title-key="error-messages.page-not-found-title"
    text-key="error-messages.page-not-found"
  />

  <div v-else class="error-page">
    <div class="error-wrapper">
      <h2 class="error-status-code">
        {{ error?.statusCode }}
      </h2>
      <div class="error-message-wrapper">
        <p>{{ error?.statusMessage || error?.message }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from "#app"
import Logger from "@/utils/Logger"

const props = defineProps({
  error: Object as () => NuxtError,
})

if (process.dev)
  Logger().error(props.error)
</script>

<style lang="scss" scoped>
.error-page {
  display: grid;
  place-content: center;
  height: 100dvh;
  padding: 15px;
}

.error-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  max-width: 100%;
}

.error-status-code {
  font-size: 250px;
  font-weight: 900;

  @media (width <= 733px) {
    font-size: 150px;
  }
}

.error-message-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  padding: 15px;

  background: #F0F0F2;
  border-radius: 20px;

  p {
    font-size: 19px;
    font-weight: 500;
    text-align: center;

    @media (width <= 733px) {
      font-size: 16px;
    }
  }
}
</style>
